export default __webpack_public_path__ + "52c12ae5e05eebc3320b053db88d4c60.png";